export default {
  SET_drawer(state, payload) {
    state.drawer = payload
  },

  SET_role(state, payload) {
    state.role = payload
  },

  SET_is_admin(state, payload) {
    state.is_admin = payload
  },

  SET_is_teacher(state, payload) {
    state.is_teacher = payload
  },

  SET_is_editorLeader(state, payload) {
    state.is_editorLeader = payload
  },

  SET_is_editor(state, payload) {
    state.is_editor = payload
  },
}
